module.exports = "<section class=\"login mat-typography\">\r\n\r\n    <mat-spinner *ngIf=\"!isLoggedIn\"></mat-spinner>\r\n\r\n    <h3 class=\"subheading-1\">Signing in automatically. Click the button below if there is a problem.</h3>\r\n    \r\n    <div *ngIf=\"!isLoggedIn\">\r\n      <button mat-raised-button (click)=\"login()\">Login</button>\r\n    </div>\r\n    <div *ngIf=\"isLoggedIn\">\r\n      <button mat-raised-button (click)=\"logout()\">Logout</button>\r\n    </div>\r\n\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main